export default __webpack_public_path__ + "static/media/cover2-exemple.0853dfb7.png";